export const validation = {
  accessCode: {
    presence: {
      message: 'Please enter a valid access code',
    },
  },
}
